import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'

import MediaUpload from 'components/MediaUpload'
import Multifield from 'components/Multifield'
import { RichTextFormField } from 'components/RichTextEditor'

const Feed = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Summary'>
        <RichTextFormField
          label='Page Summary'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='List Headline' labelFor='dynamic-headline'>
        <Textfield
          id='dynamic-headline'
          placeholder='List Headline'
          name='listHeadline'
          value={content.listHeadline || ''}
          onChange={onChange('listHeadline')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Category Section Title' labelFor='dynamic-section-title'>
        <Textfield
          id='dynamic-section-title'
          placeholder='Category Section Title'
          name='categoriesSectionTitle'
          value={content.categoriesSectionTitle || ''}
          onChange={onChange('categoriesSectionTitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='List Headline'>
        <Multifield type='text' value={content.feedsList} onChange={onChange('feedsList')} disabled={disabled} />
      </FieldLabel>
    </>
  )
}

const Ads = ({ screen, project, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Top Ad' labelFor='image'>
        <MediaUpload
          type='image'
          value={content.topAd || ''}
          maxHeight='100px'
          onUpload={onChange('topAd')}
          projectId={project?.meta?.id}
          path={`dynamic-${screen?.meta?.name}-topAd`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Top Ad link' labelFor='dynamic-top-ad-link'>
        <Textfield
          id='dynamic-top-ad-link'
          placeholder={'Top Ad URL'}
          name='topAdLink'
          value={content.topAdLink || ''}
          onChange={onChange('topAdLink')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Right Ad' labelFor='image'>
        <MediaUpload
          type='image'
          value={content.rightAd || ''}
          maxHeight='100px'
          onUpload={onChange('rightAd')}
          projectId={project?.meta?.id}
          path={`dynamic-${screen?.meta?.name}-rightAd`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Right Ad link' labelFor='dynamic-right-ad-link'>
        <Textfield
          id='dynamic-right-ad-link'
          placeholder={''}
          name='rightAdLink'
          value={content.rightAdLink || ''}
          onChange={onChange('rightAdLink')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

export default [
  { label: 'Feed', content: Feed },
  { label: 'Ads', content: Ads },
]
